import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Tabs, Tab, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { TypeOfFile } from './fileUpload.type';
import FileUploadDialog from './FileUploadDialog';
import PayAppUploadDialog from './PayappUploadDialog';
import { ProjectLineItemsAndSummary } from '../project/project.type';
import { Division } from '../glossary/glossary.type';
import { DrawOption } from './PayappUploadDialog';

interface UploadDialogProps {
  open: boolean;
  onClose: () => void;
  filesToAccept: { [key: string]: string[] };
  useSequentialUpload?: boolean;
  typeOfFile?: TypeOfFile;
  navigatePath?: string;
  projectId?: string;
  projectNumber?: string;
  projectName?: string;
  payappDrawId?: string;
  projectDraw?: ProjectLineItemsAndSummary;
  divisions?: Division[];
  /** Pre-fetched draws when opening PayApp upload from a project row */
  initialDraws?: DrawOption[];
  hideTabs?: boolean;
  defaultTab?: 0 | 1;
}

const UploadDialog: React.FC<UploadDialogProps> = ({
  open,
  onClose,
  filesToAccept,
  useSequentialUpload,
  typeOfFile,
  navigatePath,
  projectId,
  projectNumber,
  projectName,
  payappDrawId,
  projectDraw,
  divisions,
  initialDraws,
  hideTabs,
  defaultTab,
}) => {
  const [tabIndex, setTabIndex] = useState(defaultTab || 0);
  const [dialogTitle, setDialogTitle] = useState<React.ReactNode>('Upload Files');
  const [dialogActions, setDialogActions] = useState<React.ReactNode>(null);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth='md'>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center' }}>
        <Typography variant='h5'>{dialogTitle}</Typography>
        <IconButton onClick={onClose} sx={{ marginLeft: 'auto' }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      {!hideTabs && (
        <Tabs
          sx={{
            pl: 1, // optional left padding
            '.MuiTab-root': {
              '&:hover': {
                backgroundColor: '#eaf5f7',
              },
              fontWeight: 'bold',
            },
          }}
          value={tabIndex}
          onChange={(_, newValue) => setTabIndex(newValue)}
        >
          <Tab label='Magic Report' />
          <Tab label='PayApp' />
        </Tabs>
      )}

      <DialogContent>
        {tabIndex === 0 && typeOfFile && navigatePath && (
          <FileUploadDialog
            useSequentialUpload={useSequentialUpload}
            filesToAccept={filesToAccept}
            typeOfFile={typeOfFile}
            navigatePath={navigatePath}
            onClose={onClose}
            setDialogTitle={setDialogTitle}
            setDialogActions={setDialogActions}
          />
        )}
        {tabIndex === 1 && (
          <PayAppUploadDialog
            filesToAccept={{ 'application/pdf': ['.pdf'] }}
            projectId={projectId}
            projectNumber={projectNumber}
            projectName={projectName}
            payappDrawId={payappDrawId}
            projectDraw={projectDraw}
            divisions={divisions}
            initialDraws={initialDraws}
            onClose={onClose}
            setDialogTitle={setDialogTitle}
            setDialogActions={setDialogActions}
            context={payappDrawId ? 'project' : 'global'}
          />
        )}
      </DialogContent>
      {dialogActions && <DialogActions>{dialogActions}</DialogActions>}
    </Dialog>
  );
};

export default UploadDialog;
